import { Button } from '@wix/design-system'
import { useContent, useNext, usePageLoading } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect } from 'react'

import { markAsWixStudioAccount } from '../../../api/StudioWorkspaceService/markAsWixStudioAccount'
import { unmarkAsWixStudioAccount } from '../../../api/StudioWorkspaceService/unmarkAsWixStudioAccount'
import { usePageLogger } from '../../../bi/mfi'
import WixLogo from '../../reusable/icons/WixLogo.svg'
import { Icon1, Icon2 } from './icons'
import { TWixVibeSplit as Content } from './WixVibeSplit.content'
import { wixVibeSplitDataHooks as dataHooks } from './WixVibeSplit.dataHooks'
import s from './WixVibeSplit.scss'

// NOTE: icons for buttons are hardcoded and always shows based on option index
const OptionIndexToIcon = [<Icon1 />, <Icon2 />]

export const WixVibeSplit: FC = () => {
  const [isPageLoading] = usePageLoading()
  const next = useNext()
  const { content } = useContent<Content>()
  const { question } = content
  const pageLogger = usePageLogger()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const handleClick =
    (questionKey: string, optionKey: string, markAsStudio: boolean, unmarkAsStudio: boolean) => () => {
      if (isPageLoading) {
        return
      }
      if (markAsStudio) {
        void markAsWixStudioAccount()
      } else if (unmarkAsStudio) {
        void unmarkAsWixStudioAccount()
      }

      void pageLogger.answer({ answer: optionKey })
      next({
        [questionKey]: { values: [optionKey] },
      })
    }

  return (
    <div className={s.WixVibeSplit}>
      <div className={s.WixVibeSplit__logoBox}>
        <WixLogo className={s.WixVibeSplit__logo} />
      </div>
      <div className={s.WixVibeSplit__content}>
        <div className={s.WixVibeSplit__title} data-hook={dataHooks.title()}>
          {content.question.content.title}
        </div>
        <div className={s.WixVibeSplit__options}>
          {question.options.map((option, i) => (
            <div
              data-hook={dataHooks.option({ key: option.optionKey })}
              key={option.optionKey}
              className={s.WixVibeSplit__option}
              onClick={handleClick(question.questionKey, option.optionKey, option.markAsStudio, option.unmarkAsStudio)}
            >
              {option.tag && <div className={s.WixVibeSplit__tag}>{option.tag}</div>}
              <img className={s.WixVibeSplit__image} src={option.img.content.src} alt={option.img.content.alt} />
              <div className={s.WixVibeSplit__caption}>
                <div className={s.WixVibeSplit__optionTitle}>{option.label}</div>
                <div className={s.WixVibeSplit__optionSubtitle}>{option.description}</div>
                <Button className={s.WixVibeSplit__button}>
                  {OptionIndexToIcon[i] && OptionIndexToIcon[i]}
                  <span>{option.btn}</span>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
